// extracted by mini-css-extract-plugin
module.exports = {"container":"PictureGroup_style_container__2i8T5","pictureGroup":"PictureGroup_style_pictureGroup__1aAdZ"};